import Quill from 'quill';

const Parchment = Quill.import('parchment');

class YoutubeBlot extends Parchment.Embed {
  static create(id) {
    const node = super.create();

    node.setAttribute(
      'src',
      `https://www.youtube.com/embed/${id}`,
    );
    node.setAttribute('width', 320);
    node.setAttribute('height', 180);

    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

YoutubeBlot.blotName = 'youtube';
YoutubeBlot.tagName = 'iframe';

export default YoutubeBlot;
